<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    水贝站<br>
站点介绍<br>
水贝站位于布心片区洪湖立交与翠竹路之间的布心路上，北接草埔站；南接田贝站；北侧为太白路，南侧为水贝二路，西侧为文锦路，东侧为翠竹路。车站有A、B两个出入口，A出入口：贝丽北路,布心路（北）,翠竹路,东昌小学,松泉中学,松泉公寓,周六福珠宝，BC环球商务中心。B出入口：布心路（北）,独树村,水贝村，水贝珠宝，水贝国际中心。水贝站以白色为主色调，柱体采用白色搪瓷钢板，在标准化、简约化的装修中赋予了车站浓厚的文化气息。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:08	23:42	3号线	2分15-20秒	4分30秒<br>
双龙	06:08	23:31	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:17	23:41	3号线	3分15秒	5分钟<br>
双龙	06:16	23:31	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:17	00:41	3号线	3分15秒	5分钟<br>
双龙	06:16	00:31	3号线	3分15秒	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
贝丽北路,布心路（北）,翠竹路,东昌小学,松泉中学,松泉公寓,周六福珠宝，IBC环球商务中心<br><br>
B出入口:<br>
布心路（北）,独树村,水贝村，水贝珠宝，水贝国际中心，水贝壹号<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 水贝地铁站<br>
23路、225路、308路、M140路、M364路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>